import { ReactComponent as BenefitsWhiteIconSVG } from "./benefits-white-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconBenefitsWhite(props) {
  return <SvgIcon {...props} component={BenefitsWhiteIconSVG} viewBox="0 0 26 26" />;
}